module.exports = __webpack_public_path__ + "7f1ef2cb27d9e696dea3517040db8b4b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-1.png
// module id = 2483
// module chunks = 0